// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1Y_su","title":"Header_title__2XGdE","iconGoBack":"Header_iconGoBack__NDm3n","logo":"Header_logo__3bfYp"};